import { extractLink } from '@atlaskit/link-extractors';
import { CardAction } from '../../../view/Card/types';
import { canShowAction } from '../../../utils/actions/can-show-action';
export var extractCopyLinkAction = function extractCopyLinkAction(data, actionOptions) {
  if (!canShowAction(CardAction.CopyLinkAction, actionOptions)) {
    return;
  }
  var url = extractLink(data);
  if (!url) {
    return;
  }
  return {
    url: url
  };
};